import { Component } from 'react'
import PropTypes from 'prop-types'
import { TrackingHOC } from 'hocs'
import Feedback from 'components/Feedback'
import { connect } from 'react-redux'
import PanelButtons from 'components/Feedback/PanelButtons'
import { selectFaq } from '../Faq/selectors'
import { selectCurrentTutorial } from '../Tutorials/selectors'

const proptypes = {
  faq: PropTypes.shape({ name: PropTypes.string }),
  panel: PropTypes.bool,
  article: PropTypes.string,
  dispatch: PropTypes.func,
  contentType: PropTypes.string,
  createEvent: PropTypes.func,
  contentId: PropTypes.number,
  currentTutorial: PropTypes.array
}

class FeedbackContainer extends Component {
  state = {
    comment: '',
    resolved: null,
    showForm: false,
    feedbackEnabled: true,
    lastArticle: null,
    lastArticleType: null
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { currentTutorial } = this.props
    const { lastArticle } = this.state

    // Takes last watched article name and type
    if (
      nextProps.currentTutorial &&
      nextProps.currentTutorial[0] &&
      nextProps.currentTutorial[0].tutorial.name !== lastArticle
    ) {
      this.setState({
        lastArticle: nextProps.currentTutorial[0].tutorial.name,
        lastArticleType: 'Tutorial'
      })
    }
    if (
      nextProps.faq &&
      nextProps.faq.name !== lastArticle &&
      nextProps.currentTutorial === currentTutorial
    ) {
      this.setState({
        lastArticle: nextProps.faq.name,
        lastArticleType: 'Faq'
      })
    }
  }

  handleClick = (resolved) => {
    this.setState({ showForm: true, resolved })
  }

  handleChange = (event) => {
    this.setState({ comment: event.target.value })
  }

  handleSubmit = () => {
    const { createEvent, contentType, contentId, article } = this.props
    const { lastArticle, lastArticleType, resolved, comment } = this.state
    const generalFeedback = contentType === 'general-feedback'
    const data = {
      action: 'Feedback',
      target: contentId,
      helpful: generalFeedback ? resolved : resolved.toString(),
      comment: comment
    }

    createEvent({
      category: contentType,
      data: generalFeedback
        ? {
            ...data,
            last_article: lastArticle,
            last_article_type: lastArticleType,
            article: article
          }
        : data
    })
    this.setState({ comment: '', showForm: false, feedbackEnabled: false })
  }

  handleBlur = (e) => {
    const relatedTarget = e.relatedTarget || document.activeElement // IE11

    if (!relatedTarget || !e.currentTarget.contains(relatedTarget)) {
      this.setState({ showForm: false })
    }
  }

  generateProps = () => ({
    ...this.state,
    ...this.props,
    handleClick: this.handleClick,
    handleChange: this.handleChange,
    handleSubmit: this.handleSubmit,
    handleBlur: this.handleBlur
  })

  render() {
    return (
      <span>
        {!this.props.panel && <Feedback {...this.generateProps()} />}
        {this.props.panel && <PanelButtons {...this.generateProps()} />}
      </span>
    )
  }
}

FeedbackContainer.propTypes = proptypes

const mapStateToProps = (state) => ({
  currentTutorial: selectCurrentTutorial(state),
  faq: selectFaq(state)
})

export default connect(mapStateToProps, null)(TrackingHOC(FeedbackContainer))
